// src/redux/reducers/cartReducer.ts
import {
  UPDATE_CART_CROSS_SELL_QUANTITY,
  UPDATE_CART_QUANTITY
} from './actions';
import { UpdateCartQuantityAction } from './types';

export interface CartState {
  quantity: number;
  crossSellQuantity?: number;
}

const initialState: CartState = {
  quantity: 0,
  crossSellQuantity: 0
};

type CartActionTypes = UpdateCartQuantityAction;

const cartItemsMvp = (
  state = initialState,
  action: CartActionTypes
): CartState => {
  switch (action.type) {
    case UPDATE_CART_QUANTITY:
      return {
        ...state,
        quantity: action.quantity || 0
      };
    case UPDATE_CART_CROSS_SELL_QUANTITY:
      return {
        ...state,
        quantity: action.crossSellQuantity || 0,
        crossSellQuantity: action.crossSellQuantity || 0
      };
    default:
      return state;
  }
};

export default cartItemsMvp;
